import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";

export function useTagsApi() {
  const { apiFetch } = useAuth();

  return useMemo(
    () => ({
      getAll: () => apiFetch("/tags"),

      getById: (id) => apiFetch(`/tags/${id}`),

      create: (tagData) =>
        apiFetch("/tags", {
          method: "POST",
          body: JSON.stringify(tagData),
        }),

      update: (id, tagData) =>
        apiFetch(`/tags/${id}`, {
          method: "PUT",
          body: JSON.stringify(tagData),
        }),

      remove: (id) =>
        apiFetch(`/tags/${id}`, {
          method: "DELETE",
        }),

      incrementUsage: (id) =>
        apiFetch(`/tags/${id}/increment`, {
          method: "PATCH",
        }),
    }),
    [apiFetch],
  );
}
